import React, { useState, useEffect } from 'react';
import { Card, Toast } from 'antd-mobile';
import { Empty, Loading } from '../components';
import Trend from '../components/Trend';

import moment from 'moment';
import { timeFormatType, renderDateRange } from '../utils/timeFormat';
import { GetCostStatistics } from "../../../api/usms";

import { getSthousandsFormatNum } from '../utils/common';

/* 成本/收入趋势图 */
function BillDataTrend(props) {
    const { dates } = props;

    const [dateStatistics, setDateStatistics] = useState([]);
    const [dateLoading, setDateLoading] = useState(false);

    useEffect(() => {
        if (dates) {
            getDateBillStatistics(dates);
        }
        // eslint-disable-next-line
    }, [dates])

    const getDateBillStatistics = (dates) => {
        setDateLoading(true);
        const data = {
            StartTime: moment(dates[0]).unix(),
            EndTime: moment(dates[1]).unix(),
        }
        GetCostStatistics(data).then(res => {
            const data = getTrendData(res);
            setDateStatistics(data);
            setDateLoading(false);
        }).catch(e => {
            Toast.info(e.message || "获取数据失败");
            setDateLoading(false);
        });
    }

    const getTrendData = (list) => {
        const sortList = list.sort(function (a, b) {
            return moment(a.SendDate).unix() - moment(b.SendDate).unix();
        })
        const CostCountList = sortList.map(item => (
            {
                SendDate: item.SendDate,
                Value: item.Cost,
                Serie: "成本"
            }
        ));
        // const RevenueCountList = sortList.map(item => (
        //     {
        //         SendDate: item.SendDate,
        //         Value: item.Revenue,
        //         Serie: "收入"
        //     }
        // ));
        const data = [...CostCountList];
        return data
    }

    return <Loading loading={dateLoading} >
        <Card>
            <Card.Body>
                <div style={{ marginBottom: '10px' }}>
                    <span style={{ fontWeight: "bold" }}>{`${"成本趋势"} `}</span>
                    {dates ? renderDateRange(dates, timeFormatType.date_xg) : ""}
                </div>
                {dateStatistics && dateStatistics.length > 0 ?
                    <Trend
                        data={dateStatistics}
                        xField="SendDate"
                        yField="Value"
                        seriesField="Serie"
                        yAxis={{
                            label: {
                                formatter: (v) => `${getSthousandsFormatNum(v / 100)} 美元`,
                            },
                        }}
                        tooltip={{
                            formatter: (datum) => {
                                return { name: datum.Serie, value: `${getSthousandsFormatNum((datum.Value / 100).toFixed(2))} 美元` };
                            },
                        }}
                    /> :
                    <Empty style={{ height: '260px' }} />
                }
            </Card.Body>
        </Card>
    </Loading>
}
export default BillDataTrend